import { IFilter, IRangeFilter, IStringFilter } from 'app/shared/model/filter.model';
import { IUser, defaultValue as userDefaultValue } from 'app/shared/model/user.model';
import { IHouse } from 'app/shared/model/house.model';

export interface IFeedback {
  id?: number;
  mobile?: string;
  type?: string;
  content?: string;
  image?: string;
  user?: IUser;
  house?: IHouse;
}

export const defaultValue: Readonly<IFeedback> = {
  user: userDefaultValue
};

export interface ISearchForm {
  content?: IStringFilter;
  mobile?: IStringFilter;
  type?: IStringFilter;
  createdAt?: IRangeFilter;
  houseId?: IFilter;
}

export const defaultSearchForm: Readonly<ISearchForm> = {
  content: {
    contains: ''
  },
  mobile: {
    contains: ''
  },
  type: {
    in: []
  },
  createdAt: {
    lessOrEqualThan: '',
    greaterOrEqualThan: ''
  },
  houseId: {
    in: []
  }
};
